// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"192":"fa7ed036","425":"4cd8ac62"}[chunkId] + ".chunk.js";
};